import Modal from "components/modal/Modal";
import { StyledConfirm } from "./style";
import useAlertStore from "store/useAlertStore";
import { Button } from "components/button/Button/Button";

export const Confirm = () => {
  const {
    confirmTitle,
    confirmMessage,
    confirmCaption,
    confirmToggle,
    confirmMethod,
  } = useAlertStore();

  return (
    <Modal title={confirmTitle} modalToggle={confirmToggle} fitSize={true}>
      <StyledConfirm>
        <p className="title">
          <span>{confirmMessage}</span>
        </p>
        <div className="footer-wrap">
          <Button
            color="primary"
            type="solid"
            size="large"
            label={confirmCaption}
            width="12rem"
            onClick={() => {
              confirmMethod();
              confirmToggle(false);
            }}
          />
        </div>
      </StyledConfirm>
    </Modal>
  );
};
